import { render, staticRenderFns } from "./LeadButtons.vue?vue&type=template&id=3d2c03c0&lang=html"
import script from "./LeadButtons.vue?vue&type=script&lang=js"
export * from "./LeadButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports